<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="6" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                        @click="
              show = false;
              registration_no = null;
            "
                    />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        return-object
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @change="getStud()"
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        v-model="registration_no"
                        rounded
                        color="#0F2027"
                        :items="stud_list"
                        label="Select Student"
                        item-text="name"
                        return-object
                        @change="
              addtomarksheet();
              getAnnualMarksheet();
            "
                        outlined
                        dense
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="tenant == 'desschool'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="resultType"
                        :items="resultTypeOptions"
                        item-text="label"
                        item-value="value"
                        label="Select Result Type"
                        outlined
                        persistent-hint
                        hint="Please select Result type"
                    />
                </v-col>
                <v-col cols="12" sm="6" md="2" v-if="sel_ay_data && sem && registration_no">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <!-- <span v-if="show == true && sem.display_name !='Annual'">
            <span v-if="standard == 'Nursery' || standard == 'Jr.KG.' || standard == 'Sr.KG.'">
                <primary-learner-marksheet-admin></primary-learner-marksheet-admin>
            </span>
            <span v-else>
                <learner-marksheet-admin></learner-marksheet-admin> 
            </span>
        </span>
        <span v-if="show == true && sem.display_name =='Annual' && anuual_report == true">
            <span v-if="registration_no.standard == 'IX' || registration_no.standard == 'X'">
               <annual-marksheet-admin-secondary></annual-marksheet-admin-secondary>
            </span>
            <span v-else>
                <annual-marksheet-admin></annual-marksheet-admin>
            </span>
        </span> -->
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import LearnetMarksheetOfAdmin from "./Parent_Lerner_Marksheet";
    import PrePrimaryMarksheetParent from "./PrePrimaryMarksheetParent";
    import "jspdf-autotable";
    import AnnualMarksheet from "./AnnualMarksheet";
    import AnnualReportSecondary from "./AnnualReportSecondary";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            "learner-marksheet-admin": LearnetMarksheetOfAdmin,
            "primary-learner-marksheet-admin": PrePrimaryMarksheetParent,
            "annual-marksheet-admin": AnnualMarksheet,
            "annual-marksheet-admin-secondary": AnnualReportSecondary,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                dob: null,
                roll_no: null,
                mobile_no: null,
                address: null,
                mother_name: null,
                photo: null,
                reg_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                semester: null,
                colspan: null,
                overall_grade: null,
                remark: [],
                anuual_report: false,
                orgid:null,
                tenant:null,
                viewType: null,
                // viewTypeOptions: [
                //     { label: "Admin View", value: "admin" },
                //     { label: "Parent View", value: "parent" },
                // ],
                resultType : null,
                resultTypeOptions: [
                    { label: "Regular Result", value: "regular" },
                    { label: "Re-exam", value: "reexam" },
                ],
            };
        },

        methods: {
            saveremark() {
                const data = {
                    lms_id: this.leraner_marksheet.lms_id,
                    remark: this.remark,
                };
                axios
                    .post("/Examination/saveremark", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Remark save successfully...!");
                            this.getreport();
                            this.dialog_marks = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.remark = [];
                    });
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            getAnnualMarksheet() {
                if (this.sem.name == "Annual") {
                    const data = {
                        lid: this.registration_no.registration_number,
                        ay: this.sel_ay_data.ay_id,
                        sem: this.sem.id,
                    };
                    axios
                        .post("/Examination/checkAnnualMarksheet", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.flag == "No") {
                                    this.showSnackbar("#b71c1c", "Please generate both semester marksheet...");
                                    this.anuual_report = false;
                                }
                                if (res.data.flag == "Yes") {
                                    this.anuual_report = true;
                                }
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong...");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        })
                        .finally(() => {
                            this.comp_load = false;
                        });
                }
            },
            addtomarksheet() {
                // alert(this.registration_no.registration_number)
                if (this.sem.name != "Annual") {
                    const data = {
                        lid: this.registration_no.registration_number,
                        ay: this.sel_ay_data.ay_id,
                        sem: this.sem.id,
                    };
                    axios
                        .post("/Examination/getStudentReport", data)
                        .then((res) => {})
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                        })
                        .finally(() => {});
                }
            },
            getreport() {
                // this.$store.commit("setay", this.sel_ay_data.ay_id);
                // this.$store.commit("setsem", this.sem.id);
                // this.$store.commit("setreg_no", this.registration_no);
                // this.show = true;
                //  if (this.sem.display_name == "Annual" && this.anuual_report == true) {
                //     this.$store.commit("setay", this.sel_ay_data.ay_id);
                //     this.$store.commit("setsem", this.sem.id);
                //     this.$store.commit("setreg_no", this.registration_no.registration_number);
                //     this.show = true;
                // } else {
                //     this.$store.commit("setay", this.sel_ay_data.ay_id);
                //     this.$store.commit("setsem", this.sem.id);
                //     this.$store.commit("setreg_no", this.registration_no.registration_number);
                //     this.show = true;
                // }
                //     console.log(this.registration_no)
                //    alert(this.registration_no.check_ld)
                if (this.registration_no.check_ld == "NO") {
                    this.showSnackbar("#b71c1c", "Learner division not found please contact admin for report card...");
                    return;
                }
                if (this.registration_no.check_ld == "YES") {
                    this.standard = this.registration_no.standard;
                    //alert(this.standard)
                    if (this.sem.name == "Annual" && this.anuual_report == true) {
                        localStorage.setItem("setay", this.sel_ay_data.ay_id);
                        localStorage.setItem("setsem", this.sem.id);
                        localStorage.setItem("setreg_no", this.registration_no.registration_number);
                        this.show = true;
                        localStorage.setItem("setsem_name", this.sem.name);
                        localStorage.removeItem("isBulk");
                        localStorage.setItem("isBulk", "false");
                        localStorage.setItem("viewType", "parent");
                        localStorage.setItem("resultType", this.resultType);
                        if(this.tenant == 'sanjivani'){
                            if(this.orgid == 1 || this.orgid == 2 || this.orgid == 3){
                                if(this.standard == "IV" 
                                || this.standard == "V" 
                                || this.standard == "VI" 
                                || this.standard == "VII" 
                                || this.standard == "VIII"){
                                    let routeData = this.$router.resolve({
                                        name: "sgs-cbse-annual-marksheet",
                                    });
                                    window.open(routeData.href, "_blank");
                                }
                                else{
                                    let routeData = this.$router.resolve({
                                        name: "hpc-marksheet",
                                    });
                                    window.open(routeData.href, "_blank");
                                }
                            }
                        }else if(this.tenant == 'desschool'){
                            let routeData = this.$router.resolve({
                                    name: "des-template-marksheet",
                                });
                                window.open(routeData.href, "_blank");
                        }
                        else if(this.tenant == 'saisa'){
                            if (this.standard == "I" 
                            || this.standard == "II" 
                            || this.standard == "III" 
                            || this.standard == "IV"
                            || this.standard == "V") {
                            let routeData = this.$router.resolve({
                                    name: "saisa-cbse-annual-marksheet",
                                });
                                window.open(routeData.href, "_blank");
                            }else {
                                let routeData = this.$router.resolve({ name: "sbpps-ams-2" });
                                window.open(routeData.href, "_blank");
                            }
                        }
                        else{
                            if (this.standard == "IX" || this.standard == "X") {
                                let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                                if (this.sel_ay_data.ay == "2021-22") {
                                    let routeData = this.$router.resolve({ name: "sbpps-secondary-ams" });
                                    window.open(routeData.href, "_blank");
                                } else{ //if (this.sel_ay_data.ay == "2022-23" || this.sel_ay_data.ay == "2023-24" || this.sel_ay_data.ay == "2024-25") {
                                    let routeData = this.$router.resolve({ name: "sbpps-secondary-ams-22-23" });
                                    window.open(routeData.href, "_blank");
                               }
                            }
                            if (this.standard == "XI (Comm)" || this.standard == "XI (Sci)" || this.standard == "XII (Comm)" || this.standard == "XII (Sci)") {
                                //let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                                let routeData = this.$router.resolve({ name: "sbpps-secondary-ams-xi" });
                                window.open(routeData.href, "_blank");
                            }
                            if (this.standard == "Nursery" || this.standard == "Jr.KG." || this.standard == "Sr.KG.") {
                                //  alert("in annual")
                                let routeData = this.$router.resolve({
                                    name: "sbpps-preprimary-ms-parent-annual",
                                });
                                window.open(routeData.href, "_blank");
                            } else {
                                let routeData = this.$router.resolve({ name: "sbpps-ams-2" });
                                window.open(routeData.href, "_blank");
                            }
                        }
                    } else {
                        localStorage.setItem("setay", this.sel_ay_data.ay_id);
                        localStorage.setItem("setsem", this.sem.id);
                        localStorage.setItem("setreg_no", this.registration_no.registration_number);
                        localStorage.setItem("setsem_name", this.sem.name);
                        localStorage.removeItem("isBulk");
                        localStorage.setItem("isBulk", "false");
                        localStorage.setItem("viewType", "parent");
                        localStorage.setItem("resultType", this.resultType);
                        this.show = true;
                        if(this.tenant == 'desschool'){
                            let routeData = this.$router.resolve({
                                    name: "des-template-marksheet",
                                });
                                window.open(routeData.href, "_blank");
                        }else{
                            if (this.standard == "Nursery" || this.standard == "Jr.KG." || this.standard == "Sr.KG.") {
                                let routeData = this.$router.resolve({
                                    name: "sbpps-preprimary-ms-parent",
                                });
                                window.open(routeData.href, "_blank");
                            } else if (this.standard == "XI (Comm)" || this.standard == "XI (Sci)" || this.standard == "XII (Comm)" || this.standard == "XII (Sci)") {
                                let routeData = this.$router.resolve({ name: "sbpps-hsc-ms-parent" });
                                window.open(routeData.href, "_blank");
                            } else {
                                let routeData = this.$router.resolve({
                                    name: "sbpps-primary-ms-parent",
                                });
                                window.open(routeData.href, "_blank");
                            }
                        }
                    }
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                (this.stud_list = []), (this.registration_no = null);
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/AccountingAndFees/getChildList_for_marksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if ((res.data.status = "SUCCESS")) {
                                this.stud_list = res.data.learners;
                            } else {
                                alert(res.data.status_reason);
                            }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        //  this.semester_list = ["Annual"];
                        // this.sem = "Annual";
                        this.semester_list = res.data.sem_list;
                        // this.semester_list.unshift("Annual");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.orgid = localStorage.getItem("EPS-org-id");
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            font-weight: bold !important;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    ol.s {
        list-style-type: inherit;
    }
</style>
